<style scoped>
.v-text-field {
  padding-top: 0px !important;
  margin-top: 4px !important;
}

.v-input {
  font-size: 12px !important;
}

.sparkcard {
  cursor: pointer;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}
.v-btn--small {
    font-size: 10px;
    height: 22px;
    padding: 0 6px 3px 6px;
    margin: 0px 4px;
    min-width: 10px;
}
.caption {
  text-transform: capitalize;
}

.v-card.active {
  background: linear-gradient(90deg, #05f, #09f) !important;
}
</style>
<template>
<vue-perfect-scrollbar class="scroll-area" :settings="settings">
  <v-container fill-height grid-list-sm ma-0 pa-0 style="border: 0px; height: 100% " fluid>
    <!--<v-layout ma-0 pa-0 style="border: 0px" row>-->
    <v-layout ma-0 pa-0 style="border: 0px" row wrap align-center>
      <v-flex class="xs12" v-for="item in chart.chartData.series" v-if="chart.chartData.series.length">
        <div v-bind:class="[activeId == item.name ? 'sparkcard active' : 'sparkcard']" class="sparkcard" :style="activeId == item.name ? chart.chartData.activeCanvasStyle : chart.chartData.canvasStyle">

          <div :class="chart.chartData.fontClass" :style="activeId == item.name ? chart.chartData.activeFontStyle : chart.chartData.fontStyle">
            <div class="caption font-weight-medium" style="display: absolute; top: 20px; left: 10px">
              {{ chart.chartData.title }}
            </div>
            <div class="display-2">{{ chart.chartData.currency }}{{ format(item.sum, chart.chartData.format) }}</div>
            <div class="caption font-weight-medium" style="margin-bottom: 3px;">
              <v-btn v-if="item.change > 0" small green color="green darken-4" dark><v-icon dark>arrow_drop_up</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              <v-btn v-if="item.change < 0" small green color="red darken-4" dark> <v-icon dark>arrow_drop_down</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              <!--<v-btn v-if="item.change == 0 && chart.chartData.sparklineType != 'none'" small grey color="grey darken-1" dark > No Change </v-btn>-->
              <span>{{ chart.chartData.transformItem.comparison }}</span>
            </div>
          </div>
          <apexchart v-if="chart.chartData.sparklineType == 'area'" type="area" :height="50" width="100%" :options="chart.chartData.options" :series="chart.chartData.series" />
          <apexchart v-if="chart.chartData.sparklineType == 'bar'" type="bar" :height="50" width="100%" :options="chart.chartData.options" :series="chart.chartData.series" />
          <apexchart v-if="chart.chartData.sparklineType == 'line'" type="line" :height="50" width="100%" :options="chart.chartData.options" :series="chart.chartData.series" />
          <div v-if="chart.chartData.sparklineType == 'none'" style="padding-bottom: 10px"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>

</vue-perfect-scrollbar>
</template>
<script>
import numeral from 'numeral';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VueApexCharts from 'vue-apexcharts';

import {
  createNamespacedHelpers
}
from 'vuex';
const chartNamespace = createNamespacedHelpers('charts');

const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea']
]
export default {
  props: ['chart'],
  data: function() {
    return {
      activeId: null,
      settings: {
        maxScrollbarLength: 60
      },
      dateFrom: new Date().toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      menu: false,
      menuFrom: false,
      menuTo: false,
      modal: false,
      menu2: false,
      width: 5,
      radius: 10,
      padding: 8,
      lineCap: 'round',
      gradient: gradients[5],
      gradientDirection: 'top',
      gradients
    };
  },
  methods: {
    ...chartNamespace.mapMutations(['mSetFilter', 'mRemoveFilter']),

    setFilter: function(name, activeFilter) {
      console.log("filter 1");
      if (!activeFilter) {
        return false;
      }
      console.log("filter 2");
      // console.log(this.chart.id);
      const filterId = "filter_" + this.chart.id;
      const filter = {
        field: this.chart.chartData.group,
        operator: "=",
        value: name
      };
      const params = {
        id: filterId,
        filter: filter,
        exclude: [this.chart.id]
      };

      if (this.activeId == name) {
        this.activeId = null;
        this.mRemoveFilter(params);
      } else {


        this.mSetFilter(params);
        this.activeId = name;
      }
      // console.log(name);
    },
    rendered: function() {

    },
    format: function(val, format) {
      // console.log("format", format);
      if (!format) {
        return val;
      }
      return numeral(val).format(format);
    }
  },
  computed: {

  },
  components: {
    'vue-perfect-scrollbar': VuePerfectScrollbar,
    'apexchart': VueApexCharts
  },
  mounted: function() {

  }
}
</script>
